import { render, staticRenderFns } from "./ConfirmUpload.vue?vue&type=template&id=4927a63a&scoped=true&lang=pug&"
import script from "./ConfirmUpload.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpload.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUpload.vue?vue&type=style&index=0&id=4927a63a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927a63a",
  null
  
)

export default component.exports